// extracted by mini-css-extract-plugin
export default {"itemRow":"kRQ7lId_Pq_LMLYIFK7h","tooltip":"PcqqYglRxnzoeml9zJk7"};